import * as Sentry from '@sentry/react';
import { Extras } from '@sentry/types';

import { isBrowser } from '@/common/const';

interface CustomSentryErrorProps {
  name: string;
  message: string;
  stack?: any;
  options?: { extra?: Extras; level?: Sentry.Severity; sentryOption?: any };
}

export class CustomError extends Error {
  constructor({ name, message, stack }: { stack?: any; name?: string; message?: string }) {
    super();
    this.name = name || 'customError';
    this.message = message || 'customErrorMessage';
    this.stack = stack;
  }
}

export function reportCustomError({ name, message, stack, options }: CustomSentryErrorProps): void {
  try {
    if (isBrowser) {
      const { extra, level, sentryOption = {} } = options ?? {};
      const customError = new CustomError({ name, message, stack });
      Sentry.captureException(customError, {
        extra, // 附带的数据
        level: level ?? Sentry.Severity.Error, // 错误等级
        ...(sentryOption ?? {})
      });
    }
  } catch (e) {
    console.error(e);
  }
}
